import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";

function Form() {

    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();
    const profileFilter = chooseProfileFilter();

    const path = '/fiscalcategories/';
    const paths = {
        endpointSave: config.endpoints.backend + 'fiscalcategories/save',
        endpointGetById: config.endpoints.backend + 'fiscalcategories/getById',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const hiddenValues = {}

    if (profileFilter.pdc_entity_id) {
        hiddenValues.pdc_entity_id = profileFilter.pdc_entity_id
    }

    const labels = {
        labelTitleAdd: "Nova Categoria Tributária",
        labelTitleEdit: "Editar Categoria Tributária",
        labelTitleView: 'Visualizar Categoria Tributária'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues
            },
            fields: [
                !hiddenValues.pdc_entity_id ? {
                    name: 'pdc_entity_id',
                    type: 'select',
                    label: 'Entidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllEntities,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                } : {},
                {
                    name: 'description',
                    type: 'text',
                    label: 'Descrição',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'print_order',
                    type: 'integer',
                    label: 'Ordem de Impressão',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'observation',
                    type: 'textarea',
                    label: 'Observação',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
